import styled from 'styled-components'
import { DARK_VIOLET } from '../../styles/colors'
import { GIVONIC } from '../../styles/fonts'

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ButtonContainer = (styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 8px;
  width: 100%;
  border-radius: 100px;
  border: 1px solid ${DARK_VIOLET};
  background: transparent;
  appearance: none;
  cursor: pointer;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ButtonText = (styled.span`
  color: ${DARK_VIOLET};
  font-family: ${GIVONIC.semiBold};
  margin-top: 1px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
